export default {"src":"/_next/static/media/feature-icon1-1.b96f1c37.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};